import { defineComponent } from 'vue';
export default defineComponent({
    emits: ['click'],
    props: {
        type: {
            type: String,
            default: 'monthly'
        }
    },
    setup() {
        //
    }
});
